import { Button, Divider, Drawer, Popconfirm, Table } from "antd";
import { TicketViewModel } from "../../../interfaces";
import { useSelector } from "react-redux";
import { AuthenticationState } from "../../../interfaces/users";
import { useQuery } from "react-query";
import { api } from "../../../config";
import { assembleStatusTitles } from "../../../utils";
import Link from "antd/es/typography/Link";
import { useState } from "react";
import { Event } from "../../AssemblyCalendar/RescheduleAssemblyEvent/RescheduleAssemblyEvent";

interface TicketDrawerProps {
  open: boolean;
  onClose: () => void;
  ticketId: any;
  event?: any;
  buttons?: { text: string; danger?: boolean; onClick: () => void }[];
}
const TicketDrawer = ({
  open,
  onClose,
  ticketId,
  event,
  buttons,
}: TicketDrawerProps) => {
  const { token } = useSelector((state: AuthenticationState) => state);
  const [loading, setLoading] = useState(false);
  const { data: ticket } = useQuery<TicketViewModel>(`ticket-${ticketId}`, () =>
    api(token).get(`ticket/assemble/${ticketId}`)
  );

  return (
    <>
      <Drawer
        title={
          <Link href={`/montagem?id=${ticketId}`} underline target="_blank">
            {ticket?.title}
          </Link>
        }
        placement={"right"}
        closable={true}
        open={open}
        onClose={onClose}
        size="large"
        className="w-full"
      >
        {ticket && (
          <>
            <h3>Cliente: {ticket?.client?.name}</h3>
            <h4>
              Status: {ticket?.status && assembleStatusTitles[ticket?.status]}
            </h4>
            <h4>ID Venda: {ticket?.saleId}</h4>
          </>
        )}

        <h4>
          Montador: {ticket?.owner?.fullName ?? event?.assembler?.fullName}
        </h4>
        {(ticket as any)?.scheduledBy && (
          <h4>
            Agendado por: <b>{(ticket as any).scheduledBy}</b>
          </h4>
        )}

        {event?.description && <h4>Descrição: {event.description}</h4>}

        {buttons ? (
          <div className="flex flex-col gap-3">
            {buttons.map((button) => (
              <div>
                {button.danger ? (
                  <Popconfirm
                    zIndex={5000}
                    onConfirm={button?.onClick}
                    title={`Tem certeza que deseja ${button.text}?`}
                    okText="Sim"
                    cancelText="Não"
                  >
                    <Button type="primary" danger={button.danger}>
                      {button.text}
                    </Button>
                  </Popconfirm>
                ) : (
                  <Button
                    type="primary"
                    danger={button.danger}
                    onClick={async () => {
                      setLoading(true);
                      await button?.onClick();
                      setLoading(false);
                    }}
                    loading={loading}
                  >
                    {button.text}
                  </Button>
                )}
              </div>
            ))}
          </div>
        ) : null}
        {ticket && (
          <>
            <Divider></Divider>
            <h3>Produtos</h3>
            <Table dataSource={ticket?.products} rowKey="id" className=" ">
              <Table.Column
                title="Descrição"
                dataIndex="description"
                key="description"
              />
              <Table.Column
                title="Quantidade"
                dataIndex="quantity"
                key="quantity"
              />
              <Table.Column
                title="Senioridade"
                dataIndex={["seniority", "name"]}
                key="seniority"
              />
              <Table.Column
                title="Tempo de Montagem"
                dataIndex={"assemblyTime"}
                render={(value) => `${value || 0} Horas`}
                key="assemblyTime"
              />
            </Table>
          </>
        )}
      </Drawer>
    </>
  );
};

export default TicketDrawer;
